import type { ChipBg } from "~/types";
import moment from "moment/moment";
import { assign } from "lodash-es";

export default function (collection: {
  aired_at: string;
  is_new_episode?: boolean;
  is_live?: boolean;
  is_airing_today?: boolean;
}) {
  const chipInfo = computed(() => {
    const chipInfo = {
      icon: undefined,
      label: "",
      bg: "white" as ChipBg,
    };

    if (collection.is_live) {
      assign(chipInfo, {
        label: "Live",
        bg: "primary",
        icon: ["fass", "signal-stream"],
      });
    } else if (collection.is_new_episode) {
      assign(chipInfo, { label: "New Episode" });
    } else if (collection.is_airing_today) {
      assign(chipInfo, { label: "Tonight" });
    }

    return chipInfo;
  });

  const isOnAir = computed(() => {
    if (!collection.aired_at) {
      return false;
    }
    const airDate = moment(collection.aired_at);
    const now = moment();
    return now.isAfter(airDate);
  });

  return { chipInfo, isOnAir };
}
